import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://erp.gelatus.co/api',
  timeout: 60000, // 60s — el chat con Latu puede hacer varias llamadas seguidas (herramientas) y tardar más de los 15s originales
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('gelatus_app_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('gelatus_app_token');
      localStorage.removeItem('gelatus_app_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
